export default __webpack_public_path__ + "static/media/GuyAnimation8.33cef50f.svg";